import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { PATH_HOME } from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { Welcoming } from '../../components/Illustrations/Welcoming';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const HomePage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Home);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Accueil')}</title>
      </Helmet>
      <Breadcrumbs paths={[{ to: PATH_HOME, label: 'accueil', key: 'home' }]} />
      <PageTitle title="Accueil" />
      <Welcoming />
    </>
  );
};
